/**
 * Does a one level deep check for equality on object properties
 * @param  {Object}  objA An object to compare
 * @param  {Object}  objB The other object to compare
 * @return {Boolean} returns true if each object property value match
 */
export function isObjEqual( objA, objB ) {
    const a = Object.getOwnPropertyNames( objA );
    const b = Object.getOwnPropertyNames( objB );

    return a.length !== b.length
           ? false
           : a.every( prop => objA[ prop ] === objB[ prop ] );
}

/**
 * Calculates hours/days/minutes between two dates
 * @param  {Object} futureDate Date object representing the future when the
 *                             countdown will end
 * @param  {Object} date       An optional date object. Defaults to current date.
 * @return {Object}            Object containing days, hours, minutes
 */
export function calculateCountdown( futureDate, date = new Date() ) {
    let now = date.getTime();
    let future = futureDate.getTime();
    let diff = ( ( future - now ) / 1000 ) / 60;
    let minutes, hours, days;

    minutes = ~~( diff % 60 );
    diff = diff / 60;

    hours = ~~( diff % 24 );
    days = ~~( diff / 24 );

    return { days, hours, minutes };
}

/**
 * Gets red, green, and blue values from a valid hex color string, e.g. #ff00ff
 * @param  {string} hex     A valid hex color string starting with a # sign
 * @return {object|boolean} Object containing r, g, b values or false if hex is invalid
 */
export function getRgb( hex ) {
    if ( hex && hex.charAt( 0 ) === '#' && hex.length === 7 ) {
        const color = `0x${ hex.substr( 1 ) }`;

        if ( color > 0xffffff || color < 0 ) {
            return false; // not a valid color range
        }

        const r = color >> 16;
        const g = color >> 8 & 0xff;
        const b = color & 0xff;

        return { r, g, b };
    }

    return false;
}
